export default () => {
    site.components.forms = {
        functions: {
            hide: hide,
        },
    }

    $('form[data-request-success-hide]').on('ajaxDone', (event, context, data) => {
        hide(event.currentTarget, data.result)
    })
}

function hide (form, message) {
    if (message) {
        $(form).find('.alert').html(message + '<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"><i class="fas fa-times"></i></button>').fadeIn()
    }

    $(form).find('[data-hide-on-success], .hide-on-success').fadeOut({
        complete: () => {
            $([document.documentElement, document.body]).animate({
                scrollTop: $(form).find('.alert').first().offset().top -
                    200,
            }, 0)
        },
    })
}
